<mat-progress-bar mode="indeterminate" *ngIf="loading" class="in-page-loading-progress-bar"></mat-progress-bar>

<div class="main-container" *ngIf="!personalAppService.isVerified" [class.loading]="loading">
    <app-step-otp (otpCompleted)="verifyInitIdentity($event)"></app-step-otp>
</div>

<div class="container app-form" *ngIf="personalAppService.isVerified " [class.loading]="loading">

    <div *ngIf="!isSubmitted">
        <div class="row">
            <div class="col-12">
                <div class="progress-container">
                    <button mat-icon-button class="back-btn no-hover-bg" (click)="previousStep(stepper)"
                        [ngClass]="{'disabled': stepper.selectedIndex === 0}"><mat-icon svgIcon="back-arrow"></mat-icon>
                    </button>
                    <mat-progress-bar mode="determinate"
                        [value]="personalAppService.percentageStepsComplete"></mat-progress-bar>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-horizontal-stepper linear #stepper orientation="horizontal"
                    [animationDuration]="personalAppService.stepperDuration">
                    <ng-container *ngIf="personalAppService.personalApplicationFg">


                        <!-- Step 1 -->
                        <mat-step [stepControl]="personalAppService.personalApplicationFg.aboutFg">
                            <app-about-step [aboutFg]="personalAppService.personalApplicationFg.aboutFg"
                                [parentStepper]="stepper"
                                (onButtonNextEvent)="onButtonNextCompleted($event)"></app-about-step>
                        </mat-step>

                        <!-- Step 2 -->
                        <mat-step [stepControl]="personalAppService.personalApplicationFg.loanTypeFg">
                            <app-loan-type-step [fg]="personalAppService.personalApplicationFg.loanTypeFg"
                                [parentStepper]="stepper" (formGroupEmitter)="handleLoanTypeStepFinalize($event)"
                                (removeApplicantEmitter)="handleLoanTypeRemoveApplicant($event)"
                                (onButtonNextEvent)="onButtonNextCompleted($event)"></app-loan-type-step>
                        </mat-step>

                        <!-- Entity Steps -->
                        <ng-container *ngIf="personalAppService.personalApplicationFg.entityFg?.controls">
                            <mat-step
                                [stepControl]="personalAppService.personalApplicationFg.entityFg?.controls!.contactPersonFg">
                                <app-contact-person
                                    [fg]="personalAppService.personalApplicationFg.entityFg!.controls.contactPersonFg"
                                    [parentFg]="personalAppService.personalApplicationFg.entityFg!"
                                    [parentStepper]="stepper"
                                    (onButtonNextEvent)="onButtonNextCompleted($event)"></app-contact-person>
                            </mat-step>

                            <mat-step
                                [stepControl]="personalAppService.personalApplicationFg.entityFg?.controls!.contactDetailFg">
                                <app-contact-detail
                                    [fg]="personalAppService.personalApplicationFg.entityFg!.controls.contactDetailFg"
                                    [parentFg]="personalAppService.personalApplicationFg.entityFg!"
                                    [parentStepper]="stepper"
                                    (onButtonNextEvent)="onButtonNextCompleted($event)"></app-contact-detail>
                            </mat-step>

                            <mat-step
                                [stepControl]="personalAppService.personalApplicationFg.entityFg?.controls!.incomeExpensesFg">
                                <app-income-expenses
                                    [fg]="personalAppService.personalApplicationFg.entityFg!.controls.incomeExpensesFg"
                                    [parentFg]="personalAppService.personalApplicationFg.entityFg!"
                                    [parentStepper]="stepper"
                                    (onButtonNextEvent)="onButtonNextCompleted($event)"></app-income-expenses>
                            </mat-step>

                        </ng-container>


                        <!-- Step 3> Individual's steps-->
                        <ng-container *ngIf="this.personalAppService.personalApplicationFg.indivFormArray">
                            <ng-container
                                *ngFor="let indFg of this.personalAppService.personalApplicationFg.indivFormArray.controls; let i = index">
                                <mat-step [stepControl]="indFg" #stepRef>
                                    <app-individual-applicant [individualFormGroup]="indFg" [parentStepper]="stepper"
                                        [currentStep]="stepRef"></app-individual-applicant>
                                </mat-step>
                            </ng-container>
                        </ng-container>

                        <!-- Application Living  Expenses Step-->
                        <mat-step [stepControl]="personalAppService.personalApplicationFg.livingExpensesFg">
                            <app-living-expenses [fg]="personalAppService.personalApplicationFg.livingExpensesFg"
                                [parentStepper]="stepper"
                                (onButtonNextEvent)="onButtonNextCompleted($event)"></app-living-expenses>
                            <!-- [parentFg]="personalAppService.personalApplicationFg.indivFormArray!.controls[0]" -->
                        </mat-step>

                           <!-- Application Liabilities Step-->
                        <mat-step [stepControl]="personalAppService.personalApplicationFg.liabilitiesFg">
                            <app-liabilities [fg]="personalAppService.personalApplicationFg.liabilitiesFg"
                                [parentStepper]="stepper"
                                (onButtonNextEvent)="onButtonNextCompleted($event)"></app-liabilities>
                            <!-- [parentFg]="personalAppService.personalApplicationFg.indivFormArray!.controls[0]" -->
                        </mat-step>

                        <!-- Summary Review Step -->
                        <mat-step [stepControl]="personalAppService.personalApplicationFg.summaryReviewFg">
                            <app-summary-review-step [fg]="personalAppService.personalApplicationFg.summaryReviewFg"
                                [parentStepper]="stepper"
                                (onButtonNextEvent)="onFinalStepNextCompleted($event)"></app-summary-review-step>
                        </mat-step>


                    </ng-container>
                </mat-horizontal-stepper>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="isSubmitted">
        <div class="col-12">
            <app-application-completed></app-application-completed>
        </div>
    </div>

    <div class="powered-by">
        Powered by <img src="assets/avanti-logo.svg" alt="Avanti Finance" />
    </div>

    @if(environment.debug == true){
    <button mat-button (click)="submit()">Submit application</button>
    }
</div>

